// FOR LOGIN AND REGISTRATION STORE
import { Tokens } from '@Utilities/enum'

import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
export default {
    namespaced: true,
    state: {
        isLoading: false,
        watermarkImage: '',
    },
    getters: {
        isLoading: state => {
            return state.isLoading
        },
        watermarkImage: state => {
            return state.watermarkImage
        },
    },
    actions: {
        async onVerifyEmail ({ commit }, payload) {
            commit('setIsLoading', true)
            try {
                const path = 'api/auth/send/otp'
                const response = await axios.post(path, payload)

                commit('setIsLoading', false)
                return response
            } catch (error) {
                console.warn(error)
            }
            commit('setIsLoading', false)
        },
        async onVerifyOtp (_, payload) {
            try {
                const path = '/api/auth/confirm/otp'
                const response = await axios.post(path, payload)

                return response
            } catch (error) {
                console.warn(error)
            }
        },
        async onLogout ({ commit }) {
            commit('setIsLoading', true)
            try {
                const path = '/api/auth/logout'
                const response = await axios.post(path)
                if (response && response.success) {
                    window.location.href = '/'
                    cookies.remove(Tokens.MenuNav);
                    cookies.remove(Tokens.Filters)
                }
            } catch (error) {
                console.warn(error)
            }
            commit('setIsLoading', false)
        },
    },
    mutations: {
        setIsLoading (state, payload) {
            state.isLoading = payload
        },
        setWatermarkImage (state, payload) {
            state.watermarkImage = payload
        },
    },
}
